import React, { useState, useEffect } from "react";
import { Box, Container, useMediaQuery } from "@mui/material";
import UserInfo from "./UserInfo";
import InstructionContent from "./InstructionContent";
import useInstructionStyle from "../../instructionStyle/default/instructionDefaultStyle";
import { decryptData } from "../../../../crypto";
import { useProfile } from "../../../../context/ProfileContext";
import { useQuestion } from "../../../../context/QuestionsContext";
import { toast } from "react-toastify";
import SubmissionPopupReLogin from "../../../../components/popups/SubmissionPopupReLogin";
import { useQuestionSection } from "../../../../hooks/iit/useQuestionSection";

function InstructionDefault() {
  const [showSidebar, setShowSidebar] = useState(false);
  const isDesktop = useMediaQuery("(min-width:768px)");
  const classes = useInstructionStyle();

  const { profile } = useProfile();
  const { question } = useQuestion();

  const examName = decryptData(sessionStorage.getItem("exam_name")) || "";

  // User info
  const user = {
    examName: examName || "",
    duration: question?.duration || "",
    candidateName: profile?.full_name || "",
    mobile: profile?.phone || "",
    rollNumber: profile?.learner_information?.roll_number || null,
    image: profile?.image_url || "N/A",
  };

  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };

  useEffect(() => {
    const examTime = new Date(sessionStorage.getItem("startDateTime"));

    //exam start toast
    if (examTime) {
      const currentTime = new Date();
      if (currentTime < examTime) {
        const timeout = setTimeout(() => {
          toast.success("The exam is now live. You can start!", {
            toastId: "examTime",
          });
          clearTimeout(timeout);
        }, examTime - currentTime);
      }
    }
  }, []);

  const { showSubmissionPopupReLogin, countdownByHead } = useQuestionSection({});

  return (
    <Box disableGutters className={classes.appContainer}>
      <Box display="flex" flexDirection={{ xs: "column", md: "row" }}>
        {!isDesktop && showSidebar && (
          <Box className={classes.backdrop} onClick={toggleSidebar} />
        )}
        <UserInfo user={user} isOpen={isDesktop ? true : showSidebar} />
        <Box
          flex={1}
          sx={{
            marginLeft: {
              md: showSidebar || isDesktop ? '18%' : 0,
              xs: 0
            },
            "@media (min-width: 800px) and (max-width:898px)": {
              marginLeft: showSidebar || isDesktop ? '20%' : 0,
              width: showSidebar || isDesktop ? '80%' : '100%'
            },
            transition: 'margin-left 300ms ease-in-out'
          }}
        >
          <InstructionContent toggleSidebar={toggleSidebar} />
        </Box>
      </Box>
      <SubmissionPopupReLogin
        open={showSubmissionPopupReLogin}
        countdown={countdownByHead}
      />
    </Box>
  );
}

export default InstructionDefault;